<template lang="pug">
	.step
		.step__title
			|Укажите данные страхователя
		.step__list
			.step__item.step__item_large
				.step__item-left
					.step__pic
						img.step__pic-elem(src="img/name.svg")
				.step__item-right
					//- .input
						//- Vue-suggestions(:model.sync="insurerName", :placeholder="'Фамилия Имя Отчество'", class="input__control", :options="suggestionOptions")
					app-suggestion(:input="schema.insurerName", @handleInput="handleInputName", :model.sync="insurerName",:options="suggestionOptions")
					//- input.input__control
					//- app-input(:input="schema.insurerName", :field.sync="insurerName")

			.step__item.step__item_small
				.step__item-left
					.step__pic
						img.step__pic-elem(src="img/monthly_calendar.svg")
				.step__item-right
					app-input(:input="schema.birthDate", :field.sync="birthDate")
			.step__item.step__item_small
				.step__item-left
					.step__pic
						img.step__pic-elem(src="img/passport.svg")
				.step__item-right
					app-input(:input="schema.passport", :field.sync="passport", @handleInput="handleInput")
			.step__item.step__item_large
				.step__item-left
					.step__pic
						img.step__pic-elem(src="img/address.svg")
				.step__item-right
					app-suggestion(:input="schema.address", :model.sync="address", :coordinates.sync="coordinates", :options="suggestionOptionsAddress")
					//- app-input(:input="schema.address", :field.sync="address")
		.step__button
			a.button.button_type-simple(href="#",  @click.prevent="handleClickPrev")
				|Назад
			a.button(href="#", ref="buttonNext", @click.prevent="handleClick")
				|Далее
</template>

<script>
// @ is an alias to /src
import AppInput from '@/components/Input.vue'
import AppSuggestion from '@/components/Suggestion.vue'
import { mapFields } from 'vuex-map-fields';
import { mapGetters } from 'vuex';
// import VueSuggestions from 'vue-suggestions';
export default {

  name: 'app-step2',
  components: {
    AppInput,
    AppSuggestion,
    // VueSuggestions
  },
  data() {
  	return {
      coordinates: {
        latitude: '',
        longitude: ''
      },
      suggestionOptions: {
        token: 'c0405a37b0a4d76fc84d794ee0b1b93d9d7f2122',
        type: "NAME",
        scrollOnFocus: false,
        triggerSelectOnBlur: true,
        triggerSelectOnEnter: false,
        addon: 'none',
        onSelect: (suggestion) => {
          this.insurerGender = suggestion.data.gender[0]
        	// this.insurerName = `${suggestion.data.surname} ${suggestion.data.name} ${suggestion.data.patronymic}`
        },
        onSelectNothing(suggestion){
        	// console.log('nothing', suggestion, this)
        	// this.insurerName = '';
        	// this.value = '';
        }
      },
      suggestionOptionsAddress: {
        // @see https://confluence.hflabs.ru/pages/viewpage.action?pageId=207454318
        token: 'c0405a37b0a4d76fc84d794ee0b1b93d9d7f2122',
        type: "ADDRESS",
        scrollOnFocus: false,
        triggerSelectOnBlur: true,
        triggerSelectOnEnter: false,
        addon: 'none',
        // @see https://confluence.hflabs.ru/pages/viewpage.action?pageId=207454320
        onSelect (suggestion) {
        	// console.log('selected',suggestion, this)
        },
        onSelectNothing(suggestion){
        	// console.log('nothing', suggestion)
        	// this.address = '';
        	this.value = '';
        	// console.log(this.nextSibling)
        }
      },
  	}
  },
  methods:{
  	handleClick(){
  		console.log(this)
  		this.$validator.validate().then(valid => {
        if (valid) {

           this.$router.push({name:'step3'})
        }
      });
		},
		handleInputName(e){
			console.log(e)
			// console.log('eee', this.insurerName)
		},
		handleClickPrev(){
			this.$router.push({name:'step1'})
		},
		handleInput(e){
			console.log(e)
		}
  },
  computed:{
  	...mapFields([
      'insurerName',
      'birthDate',
      'passport',
      'address',
      'insurerGender',
    ]),
    ...mapGetters({
		  schema: 'getSchema',
		  // popupIsActive: 'PopupIsActive'
		})
  }

}
</script>

<style lang="scss">


</style>
